// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"48868a48","122":"23aa71ef","509":"a9f9e77f","551":"6fb33061","585":"43cc4705","625":"43a72854","975":"b81e5d7d","985":"7364fe6e"}[chunkId] + ".chunk.css";
};